angular.module('Itao.IndicatorMap').directive('indicatorIndicators', function (mapConfig, communeConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'indicators.html',
    restrict: 'E',
    scope: {
      data: '=',
      treeOptions: '=',
      treeFilter: '=',
      indicators: '=',
      selectedIndicator: '=',
      onIndicatorSelect: '&'
    },
    link: function (scope) {
      scope.$watch('pattern', function (newValue) {
        if (newValue != undefined) {
          if (newValue.length > 0) {
            scope.$broadcast('angular-ui-tree:expand-all');
          } else {
            scope.$broadcast('angular-ui-tree:collapse-all');
          }
        }
      });
    }
  };
});
